<template>
  <div class="type-selector">
    <span @click="setRangeMode"
      :class="{
        'type-selector__item': true,
        'type-selector__item--active': value === 'start' || value === 'end'
      }">
      <template v-if="fallbackVersion">Daty wylot - przylot</template>
      <template v-else>Wyjazd od - do</template>
    </span>

    <span v-if="fallbackVersion" @click="setDayAndRangeMode"
      :class="{
        'type-selector__item': true,
        'type-selector__item--active': value === 'date'
      }">
      Wylot od + liczba dni
    </span>
    <span v-else @click="setMonthMode"
      :class="{
        'type-selector__item': true,
        'type-selector__item--active': value === 'month'
      }">
      Cały miesiąc
    </span>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    value: {
      type: String,
      required: false,
      default: () => 'date',
    },
    fallbackVersion: {
      type: Boolean,
      required: false,
    },
  },
})
export default class TypeSelector extends Vue {
  setRangeMode () {
    this.$emit('change', 'range')
  }

  setDayAndRangeMode () {
    this.$emit('change', 'date')
  }

  setMonthMode () {
    this.$emit('change', 'month')
  }
}
</script>

<style lang="scss">
.type-selector {
  display: flex;
  justify-content: center;
  text-transform: uppercase;

  &__item {
    display: block;
    width: 160px;
    text-align: center;
    font-size: 12px;
    padding: 6px 10px;
    color: #009FEA;
    background-color: transparent;
    border: 1px solid #009FEA;
    cursor: pointer;

    &--active {
      background-color: #009FEA;
      color: #fff;
      font-weight: bold;
    }

    &:first-child {
      border-radius: 7px 0 0 7px;
    }

    &:last-child {
      border-radius: 0 7px 7px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/calendar/TypeSelector.vue